import React from "react";
import { RadioGroup } from "@my-scoot/component-library-legacy";
import withComponentLibraryTheme from "hocs/withComponentLibraryTheme";
import { ESIGN_PLACEMENT_OPTIONS } from "../../constants/OfferingPageSections.constants";
import { UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL } from "features/AdminPanel/constants/AdminPanel.api";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import { useParams } from "react-router-dom";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import classnames from "classnames";
import {
  EXLY_SCHEDULELIST__RESET_LIVE_OFFERINGS,
  EXLY_SCHEDULELIST__RESET_SOLDOUT_OFFERINGS,
} from "ui/pages/schedule/redux/actions";
import { useDispatch } from "react-redux";

export const ESignPlacementSubSection = withComponentLibraryTheme(
  ({ subSectionKey, endPoint = UPDATE_ADMIN_PANEL_SETTINGS_LISITNG_LEVEL }) => {
    const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);
    const subSectionConfig = sectionConfig[subSectionKey] || {};
    const { value: selectedStatus } = subSectionConfig;
    const { listing_uuid } = useParams();
    const dispatch = useDispatch();

    const { handleSectionChange } = useAccountSectionUnlocking();

    const handleChange = ({ value }) => {
      const payload = {
        listing_uuid,
        feature_key: subSectionKey,
        feature_value: value,
      };
      handleSectionChange({
        endPoint,
        payload,
      });
      dispatch({ type: EXLY_SCHEDULELIST__RESET_LIVE_OFFERINGS });
      dispatch({ type: EXLY_SCHEDULELIST__RESET_SOLDOUT_OFFERINGS });
    };
    return (
      <>
        <RadioGroup
          options={ESIGN_PLACEMENT_OPTIONS}
          selected={ESIGN_PLACEMENT_OPTIONS.find(
            ({ value }) => value === selectedStatus
          )}
          onChange={handleChange}
          formControlLabelClassName={classnames(
            "!tw-whitespace-nowrap",
            "tw-text-sm md:tw-text-base"
          )}
        />
      </>
    );
  }
);
